import { createApp } from "vue";
import { createPinia } from "pinia";
import router from "./router";
import { i18n } from "@/i18n";
import App from "./App.vue";
// import * as Sentry from "@sentry/vue";

import { createHead } from "@vueuse/head";

const head = createHead();

// Bootstrap
import * as bootstrap from "bootstrap";

// Sweet Alert
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { useMainStore } from "@/store";

window.bootstrap = bootstrap;

const pinia = createPinia();

const app = createApp(App).use(pinia);
app.use(router).use(i18n).use(head).use(VueSweetalert2);

export const store = useMainStore();

// Sentry.init({
//   app,
//   environment: process.env.VUE_APP_SENTRY_ENV,
//   dsn: "https://ddd52da76a76f78b9825aaacd121b413@sentry.effetb.com/14",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   enabled: process.env.NODE_ENV === "prod",
//   tracesSampleRate: 0.2, //  Capture 20% of the transactions
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   idleTimeout: 500,
// });

router.isReady().then(() => {
  app.mount("#app");
});
